import React from 'react'
import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { Baseurl } from '../../constants/env';
import Button from 'react-bootstrap/esm/Button';

const RemoveOrderModal = (props) => {
    const [show, setShow] = useState(false);
    const [reason, setReason] = useState(false); 

    const{adminlogedin} = useSelector((state)=>state.auth);
    const{enqueueSnackbar} = useSnackbar();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // async function removeorder(id) {
  //   await axios.delete(`${Baseurl}/orderedproductdetails/${id}`, {
  //     withCredentials: true,
  //   })
  //     .then((resp) => {
  //       console.log(resp);
  //       props.removechange(resp);
  //       setShow(false)
  //       adminlogedin ? enqueueSnackbar('Success',{variant:'success'}) : enqueueSnackbar('Order Canceled',{variant:'success'})
  //     })
  //     .catch((e) => {
  //       console.log(e.message);
  //     });
  // }

  async function removeorder(id) {
    await axios.post(`${Baseurl}/cancel-order/${id}`,{reason},{
      withCredentials: true,
    })
      .then((resp) => {
        console.log(resp);
        props.removechange(resp);
        setShow(false)
        adminlogedin ? enqueueSnackbar('Success',{variant:'success'}) : enqueueSnackbar('Order Canceled',{variant:'success'})
      })
      .catch((e) => {
        console.log(e.message);
      });
  }
  return (
    <>
    <button class="btn btn-primary btn-sm btn-danger mb-0 me-2"   onClick={handleShow}  >
     {adminlogedin ? 'Order Placed' : 'Cancel Order'} 
    </button>

    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false} style={{marginTop:'150px'}}
    >
      <Modal.Header closeButton className='bg-danger'>
        <Modal.Title></Modal.Title>
      </Modal.Header>
      <Modal.Body className='text-center bg-danger text-white'>
      <div className="form-group">
        <label htmlFor="cancellation-reason">Reason for Cancellation:</label>
        <select 
          id="cancellation-reason"
          value={reason} 
          onChange={(e) => setReason(e.target.value)}
          required
        >
          <option value="">Select a reason</option>
          <option value="Changed my mind">Changed my mind</option>
          <option value="Found better price elsewhere">Found better price elsewhere</option>
          <option value="Ordered by mistake">Ordered by mistake</option>
          <option value="Shipping time too long">Shipping time too long</option>
          <option value="Other">Other</option>
        </select>
      </div>
      <p className="note">
        Note: Refunds typically take 5-7 business days to process depending on your payment method.
      </p>
       Are You Sure ? 
      </Modal.Body>
      <Modal.Footer className='bg-danger'>
        <Button onClick={handleClose}>
          No
        </Button>
        <Button className='bg-warning' onClick={(e) => {removeorder(props.id)}}>Yes</Button>
      </Modal.Footer>
    </Modal>
  </>
  )
}

export default RemoveOrderModal
